import { IIconProps } from "../types"

export default function IconUL2(props: IIconProps) {
  const width = props.size || props.width || 65
  const height = props.size || props.height || 89
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 65 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.482 0.814245C28.502 0.974245 26.412 1.43424 24.532 2.47424C22.642 3.51424 20.952 5.14424 19.382 7.22424C17.822 9.31424 16.392 11.8442 13.692 20.2842C10.982 28.7142 7.01201 43.0342 4.70201 52.2142C2.39201 61.3942 1.74201 65.4342 1.28201 68.8142C0.832012 72.2042 0.572012 74.9342 0.892012 77.2842C1.22201 79.6242 2.13201 81.5742 3.43201 83.1042C4.73201 84.6342 6.43201 85.7442 9.03201 86.4942C11.642 87.2442 15.152 87.6342 20.752 87.7942C26.352 87.9542 34.032 87.8942 39.662 87.4042C45.302 86.9142 48.882 86.0042 51.802 84.8642C54.732 83.7242 57.012 82.3542 58.642 80.7342C60.272 79.1042 61.252 77.2142 61.932 75.5842C62.612 73.9642 63.002 72.5942 63.202 70.8342C63.392 69.0742 63.392 66.9242 62.252 60.6142C61.122 54.2942 58.842 43.8142 56.402 35.0942C53.952 26.3642 51.352 19.4042 48.942 14.4542C46.532 9.50424 44.322 6.57424 42.242 4.65424C40.152 2.73424 38.202 1.82424 36.282 1.30424C34.362 0.784245 32.472 0.654245 30.482 0.814245Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
